"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.register = register;
var _react = _interopRequireDefault(require("react"));
var _client = require("react-dom/client");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var componentsRegistry = {};
function register(components) {
  Object.keys(components).forEach(function (name) {
    if (name in componentsRegistry) {
      console.warn("Called register for component that is already registered", name);
    }
    var component = components[name];
    if (!component) {
      throw new Error("Called register with null component named ".concat(name));
    }
    componentsRegistry[name] = component;
  });
}
function reactHtmlElements() {
  return document.getElementsByClassName("custom-react-component-render");
}
function render(el) {
  var name = el.getAttribute("data-component-name") || "";
  var domNodeId = el.getAttribute("data-dom-id") || "";
  var props = el.textContent !== null ? JSON.parse(el.textContent) : {};
  try {
    var domNode = document.getElementById(domNodeId);
    if (domNode) {
      var Component = componentsRegistry[name];
      if (Component != null) {
        var ReactElement = _react["default"].createElement(Component, props);
        var root = (0, _client.createRoot)(domNode);
        root.render(ReactElement);
        window.reactComponentsRoots.push(root);
      }
    }
  } catch (e) {
    console.error(e.message);
    e.message = "Encountered an error while rendering component: ".concat(name, ". See above error message.");
    throw e;
  }
}
function reactPageUnloaded() {
  var _window$reactComponen;
  var _iterator = _createForOfIteratorHelper((_window$reactComponen = window.reactComponentsRoots) !== null && _window$reactComponen !== void 0 ? _window$reactComponen : []),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var root = _step.value;
      root.unmount();
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function reactPageLoaded() {
  window.reactComponentsRoots = [];
  var els = reactHtmlElements();
  for (var i = 0; i < els.length; i += 1) {
    render(els[i]);
  }
}
function onPageReady(callback) {
  if (document.readyState === "complete") {
    callback();
  } else {
    document.addEventListener("readystatechange", function onReadyStateChange() {
      onPageReady(callback);
      document.removeEventListener("readystatechange", onReadyStateChange);
    });
  }
}
function onPageLoaded() {
  document.addEventListener("turbolinks:before-render", reactPageUnloaded);
  document.addEventListener("turbolinks:render", reactPageLoaded);
  reactPageLoaded();
}
onPageReady(onPageLoaded);